import React from 'react'
import { useTranslation } from 'react-i18next';
import { useAllowedCountries } from '../../../hooks/useRoutes';
import { useSelector } from 'react-redux';
import { useInitUser } from '../../../hooks/useUser';
import { useClientEntity } from '../../../hooks/useUser';
import { LoaderSpinner } from '../../shared/simple/LoaderSpinner';
import { Label } from '../../shared/simple/Label';
import { RouterLink } from '../../shared/simple/RouterLink';
import { routes } from '../../../constants/routes';
import { Link } from '../../shared/simple/Link';
import { envSetting } from '../../../constants/envSetting';
import { ControllerInput } from '../../shared/Input/ControllerInput';
import { PhoneNumberInput } from '../../shared/Input/PhoneNumberInput';
import { Button } from '../../shared/simple/Button';
import { LinkText } from '../../shared/simple/RouterLink';
import { Select } from '../../shared/simple/Select';
import SlideCaptchaModal from '../../shared/slide-captcha-modal/SlideCaptchaModal';
import { FormProvider } from 'react-hook-form';

const AltClientEntity = ({
  setStep,
  step
}) => {
  const { t } = useTranslation();
  const { allowed } = useAllowedCountries();
  const { selectedProduct } = useSelector(state => state.user);
  const {
    appOrigin,
    isSlideModalOpen,
    loading,
    onSubmit,
    setIsSlideModalOpen,
    values
  } = useInitUser(allowed);
  const {
    country,
    errors,
    handleSubmit,
    onRegister,
    register,
    setValuesCountry,
    setValuesDocument,
    setValuePhoneCountry,
    methods
  } = useClientEntity();

  React.useEffect(() => { // ? Remove errors from client entity form, whenever step changes.
    methods.clearErrors()
  }, [step])

  const altErrorMessageStyle = {
    display: 'block',
    color: '#FF7171',
    backgroundColor: 'rgba(255, 113, 113, 0.12)',
    borderLeft: '3px solid #FF7171',
    padding: '2px 8px',
    borderRadius: '6px',
    fontSize: '0.875em',
    fontWeight: 500,
    marginTop: '2px',
    marginBotton: '0px',
    width: 'fit-content',
    textAlign: 'left',
    position: 'absolute'
  }; 

  return (
    <div>
      { step === 0 && (
        <form
          onSubmit={ handleSubmit(onSubmit) }
        >
          <h1 className="pb-4">{ t("clientEntity.title") }</h1>
          {country ? (
            <div>
              <FormProvider {...methods}>
                <ControllerInput
                  autoComplete="off"
                  disabled={ loading }
                  label={ t("clientEntity.code") }
                  message={ errors.wisenroll_code?.message }
                  name={ register("wisenroll_code").name }
                  control={methods?.control}
                  type="text"
                  labelColor='white'
                  altErrorStyle={altErrorMessageStyle}
                  methods={methods}
                />
                <Select
                  dataName={country?.country}
                  id="country_id"
                  isRequired={false}
                  isSetValue={false}
                  isStaticData={false}
                  label={t("clientEntity.country")}
                  message={errors.document_country_id?.message}
                  name={register("document_country_id").name}
                  register={register("document_country_id")}
                  setValue={setValuesCountry}
                  text="name"
                  labelColor='white'
                  altErrorStyle={altErrorMessageStyle}
                />
                <Select
                  dataName={country?.document_type}
                  id="document_type_id"
                  isRequired={false}
                  isSetValue={false}
                  isStaticData={false}
                  label={t("clientEntity.typeDocument")}
                  message={errors.document_type_id?.message}
                  name={register("document_type_id").name}
                  register={register("document_type_id")}
                  setValue={setValuesDocument}
                  text="description"
                  labelColor='white'
                  altErrorStyle={altErrorMessageStyle}
                />
                <ControllerInput
                  autoComplete="off"
                  disabled={ loading }
                  label={ t("clientEntity.documentNumber") }
                  message={ errors.document_number?.message }
                  name={ register("document_number").name }
                  control={methods?.control}
                  field={{unique_name: 'document_number'}}
                  type="text"
                  labelColor='white'
                  altErrorStyle={altErrorMessageStyle}
                />
                <ControllerInput
                  autoComplete="off"
                  disabled={ loading }
                  label={ t("clientEntity.email") }
                  message={ errors.email?.message }
                  name={ register("email").name }
                  control={methods?.control}
                  type="text"
                  labelColor='white'
                  altErrorStyle={altErrorMessageStyle}
                />
                <PhoneNumberInput
                  autoComplete="off"
                  disabled={ loading }
                  label={ t("clientEntity.phoneNumber") }
                  message={ errors.cell_phone?.message }
                  name={ register("cell_phone").name }
                  register={ register("cell_phone") }
                  type="text"
                  setCountryValue={setValuePhoneCountry}
                  labelColor='white'
                  altErrorStyle={altErrorMessageStyle}
                  groupClassName='mb-4'
                />
                <input 
                  className='d-none'
                  { ...register("cell_phone_country_id") }
                  name={ register("cell_phone_country_id").name }
                  disabled
                  readOnly
                />
                {loading
                  ? (<LoaderSpinner />)
                  : (
                    <Button
                      className="btn"
                      color="first"
                      disabled={ loading }
                      type="submit"
                      name="btn_client"
                    >
                      { t("login.buttonSignUp") }
                    </Button>
                )}
              </FormProvider>
            </div>
          ) : (<LoaderSpinner />)}
          {!loading && (
            <Label className="wantText" color='white'>
              { t("password.wantToLogin") }&nbsp;
              <LinkText color='third' onClick={() => setStep(1) }>
                { t("login.buttonLogIn") }
              </LinkText>
            </Label>
          )}
          <Label className="wantText" color='white'>
            { t("common.createAccount") }&nbsp;
            <Link
              className="p-0 col-12"
              href={ envSetting.routeCreateAccount }
              color="third"
              target="_blank"
            >
              { t("common.createAccountURL") }
            </Link>
          </Label>
        </form>
      )}
      <SlideCaptchaModal
        isOpen={ isSlideModalOpen }
        onRequestClose={ () => setIsSlideModalOpen(false) }
        onSuccess={ () => onRegister(values) }
      />
    </div>
  )
}

export default AltClientEntity